import React from 'react';
import { Container, Typography, Box, Paper, Divider, Stack } from '@mui/material';
import { Security, Visibility, Person, Cookie } from '@mui/icons-material';

const PrivacyPolicy = () => {
  const policies = [
    {
      icon: <Person color="primary" />,
      title: "Information Collection",
      content: "We collect personal information such as your name, contact details, child's school details, and purchase history. This information is collected when you create an account, place an order, or communicate with us."
    },
    {
      icon: <Visibility color="primary" />,
      title: "How We Use Your Information",
      content: "Your data is primarily used to process your orders, provide customer support, and improve our services. We may also use your contact information to send you updates regarding your orders or seasonal uniform availability."
    },
    {
      icon: <Cookie color="primary" />,
      title: "Cookies and Tracking",
      content: "We use cookies to enhance your browsing experience, remember your preferences, and analyze site traffic. You can choose to disable cookies through your browser settings, although this may affect certain features of the site."
    },
    {
      icon: <Security color="primary" />,
      title: "Data Protection",
      content: "We implement robust security measures to protect your personal data from unauthorized access, alteration, or disclosure. Only authorized employees with a business need have access to your personal information."
    }
  ];

  return (
    <Box sx={{ bgcolor: '#f0f4f8', py: 8 }}>
      <Container maxWidth="md">
        <Paper elevation={3} sx={{ p: { xs: 3, md: 6 }, borderRadius: 4 }}>
          <Typography variant="h3" component="h1" align="center" gutterBottom fontWeight="bold" color="primary">
            Privacy Policy
          </Typography>
          <Typography variant="body2" align="center" color="text.secondary" sx={{ mb: 4 }}>
            Last Updated: March 2026
          </Typography>
          
          <Divider sx={{ mb: 4 }} />
          
          <Box sx={{ mb: 6 }}>
            <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem' }}>
              At Thathva Industries, we value your privacy and are committed to protecting your personal data. This policy explains how we collect, use, and safeguard your information when you use our uniform portal.
            </Typography>
          </Box>

          <Stack spacing={4}>
            {policies.map((policy, index) => (
              <Box key={index} sx={{ display: 'flex', gap: 3, alignItems: 'flex-start' }}>
                <Box sx={{ 
                  bgcolor: 'rgba(13, 110, 253, 0.1)', 
                  p: 1.5, 
                  borderRadius: '50%', 
                  display: 'flex' 
                }}>
                  {policy.icon}
                </Box>
                <Box>
                  <Typography variant="h5" gutterBottom fontWeight="bold">
                    {policy.title}
                  </Typography>
                  <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.6 }}>
                    {policy.content}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Stack>

          <Box sx={{ mt: 6, p: 3, bgcolor: '#f8f9fa', borderRadius: 2, border: '1px solid #e0e0e0' }}>
            <Typography variant="h6" gutterBottom fontWeight="bold">
              Third-Party Partners
            </Typography>
            <Typography variant="body1" color="text.secondary" paragraph>
              We partner with ICICI Bank for secure payment processing. Your payment information is handled directly by them and is subject to their privacy policy.
            </Typography>
            <Typography variant="body1" color="text.secondary">
              We do not sell or lease your personal information to third parties for marketing purposes.
            </Typography>
          </Box>

          <Typography variant="body2" sx={{ mt: 4, textAlign: 'center', color: 'text.secondary' }}>
            By using this site, you consent to the terms of this Privacy Policy.
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
};

export default PrivacyPolicy;
